import React from "react";
import { AdminElectionResultsTab } from "@/components/admin/AdminElectionResultsTab";

export default function AdminElectionResultsPage() {
  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <AdminElectionResultsTab />
    </div>
  );
}
